export const PAGE_NOT_FOUND_IMAGE = {
    src: 'https://media.giphy.com/media/c3Xv5mtcTWde8/giphy.gif',
    href: 'https://giphy.com/gifs/c3Xv5mtcTWde8',
};
export const INTERNAL_SERVER_ERROR_IMAGE = {
    src: 'https://media.giphy.com/media/CYEadxFZFtcNG/giphy.gif',
    href: 'https://giphy.com/gifs/CYEadxFZFtcNG',
};
